let rootSelector = state => state.menu;

// Required to set the root selector externally, since the module isn't aware of the
// global state shape.
export const setRootSelector = selector => {
  rootSelector = selector;
};

export const getMenuState = state => rootSelector(state);
export const getIsHeaderActive = state => rootSelector(state).isHeaderActive;
export const getReloadApplication = state =>
  rootSelector(state).reloadApplication;
